document.querySelectorAll( '.b-tabs-simple' ).forEach( ( block ) => {

	const navButtons = block.querySelectorAll( '.js-tabs-simple-button' );
	const tabs = block.querySelectorAll( '.b-tabs-simple__panel' );

	if ( navButtons.length === 0 || tabs.length === 0 ) {

		return;

	}

	/**
	 * Activates selected tab and updates ARIA attributes.
	 *
	 * @param {number} index Active tab index.
	 */
	const setActiveTab = ( index ) => {

		navButtons.forEach( ( button, buttonIndex ) => {

			const isActive = buttonIndex === index;
			button.classList.toggle( 'is-active', isActive );
			button.setAttribute( 'aria-selected', isActive ? 'true' : 'false' );

			if ( tabs[ buttonIndex ] ) {

				tabs[ buttonIndex ].classList.toggle( 'is-active', isActive );

			}

		} );

	};

	navButtons.forEach( ( button, index ) => {

		button.addEventListener( 'click', () => {

			setActiveTab( index );

		} );

	} );

	block.classList.add( 'is-enhanced' );
	setActiveTab( 0 );

} );
